import { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';
import Button from '@base/Button/Button';
import imageHelper from '@utils/imageHelper';
import { Spacings } from '../../../styleConstants';

const Empty = styled.div`
  grid-column: ${({ $gridColumn }) => $gridColumn};
  text-align: center;
  margin-top: ${({ $marginTop }) => $marginTop};
  ${({ $rawStyles }) => $rawStyles}
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NoDataTitle = styled(H3)`
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_2B};
`;

const DescriptionP1 = styled(P1)`
  margin-bottom: ${Spacings.SPACING_4B};
`;

const EmptyImage = styled.img`
  user-drag: none;
  user-select: none;
`;

const EmptyState = ({
  imgSrc,
  title,
  description,
  gridColumn,
  marginTop,
  rawStyles,
  className,
  isCTAPresent,
  handleCTA,
  variantCTA,
  labelCTA
}) => {
  const theme = useContext(ThemeContext);

  const renderCTAButton = () => {
    if (isCTAPresent) {
      return (
        <Button
          grid={3}
          variant={variantCTA}
          label={labelCTA}
          onClick={handleCTA}
          theme="blue"
        />
      );
    }
  };

  return (
    <Empty
      $gridColumn={gridColumn}
      $marginTop={marginTop}
      $rawStyles={rawStyles}
      className={className}
    >
      <EmptyImage src={imgSrc} alt="No data" />
      <NoDataTitle color={theme.colors.fontGrey}>{title}</NoDataTitle>
      <DescriptionP1 color={theme.colors.fontDarkBlue}>
        {description}
      </DescriptionP1>
      {renderCTAButton()}
    </Empty>
  );
};

EmptyState.propTypes = {
  imgSrc: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  gridColumn: PropTypes.string,
  marginTop: PropTypes.string,
  rawStyles: PropTypes.string,
  className: PropTypes.string,
  isCTAPresent: PropTypes.bool,
  handleCTA: PropTypes.func,
  variantCTA: PropTypes.string,
  labelCTA: PropTypes.string
};

EmptyState.defaultProps = {
  imgSrc: imageHelper.getImage('empty.svg'),
  gridColumn: '7/14',
  marginTop: Spacings.SPACING_21B,
  rawStyles: '',
  className: '',
  isCTAPresent: false,
  handleCTA: () => {},
  variantCTA: '',
  labelCTA: ''
};

export default memo(EmptyState);
